import { differenceInMonths } from "date-fns";
import moment from "moment";
import { halveAllObjectValues } from "../../../mockUtils";

const shippingAllTimeValues = {
  EFFICIENT_AUXILIARY_ENGINE_USE: {
    behaviourStatusCounts: {
      countSuccess: 116,
      countExcluded: 139,
      countUnsuccessful: 106,
      countBadMissingData: 8,
    },
    countBehavioursTotal: 369,
    countBehavioursPerformable: 222,
  },
  OPTIMAL_TRIM: {
    behaviourStatusCounts: {
      countSuccess: 145,
      countExcluded: 23,
      countUnsuccessful: 72,
      countBadMissingData: 9,
    },
    countBehavioursTotal: 249,
    countBehavioursPerformable: 217,
  },
  PROMPT_DEPARTURE: {
    behaviourStatusCounts: {
      countSuccess: 97,
      countExcluded: 42,
      countUnsuccessful: 176,
      countBadMissingData: 1,
    },
    countBehavioursTotal: 316,
    countBehavioursPerformable: 273,
  },
  EFFICIENT_SFOC: {
    behaviourStatusCounts: {
      countSuccess: 340,
      countExcluded: 132,
      countUnsuccessful: 67,
      countBadMissingData: 42,
    },
    countBehavioursTotal: 581,
    countBehavioursPerformable: 472,
  },
};

const shippingMonthyValues = {
  [moment.utc().subtract(1, "month").format("YYYY/MM/DD")]: {
    EFFICIENT_AUXILIARY_ENGINE_USE: {
      behaviourStatusCounts: {
        countSuccess: 26,
        countExcluded: 27,
        countUnsuccessful: 10,
        countBadMissingData: 1,
      },
      countBehavioursTotal: 64,
      countBehavioursPerformable: 36,
    },
    OPTIMAL_TRIM: {
      behaviourStatusCounts: {
        countSuccess: 22,
        countExcluded: 5,
        countUnsuccessful: 13,
        countBadMissingData: 2,
      },
      countBehavioursTotal: 249,
      countBehavioursPerformable: 35,
    },
    PROMPT_DEPARTURE: {
      behaviourStatusCounts: {
        countSuccess: 14,
        countExcluded: 8,
        countUnsuccessful: 29,
        countBadMissingData: 0,
      },
      countBehavioursTotal: 51,
      countBehavioursPerformable: 43,
    },
    EFFICIENT_SFOC: {
      behaviourStatusCounts: {
        countSuccess: 76,
        countExcluded: 21,
        countUnsuccessful: 12,
        countBadMissingData: 4,
      },
      countBehavioursTotal: 113,
      countBehavioursPerformable: 88,
    },
  },
  [moment.utc().subtract(2, "months").format("YYYY/MM/DD")]: {
    EFFICIENT_AUXILIARY_ENGINE_USE: {
      behaviourStatusCounts: {
        countSuccess: 32,
        countExcluded: 19,
        countUnsuccessful: 29,
        countBadMissingData: 2,
      },
      countBehavioursTotal: 82,
      countBehavioursPerformable: 61,
    },
    OPTIMAL_TRIM: {
      behaviourStatusCounts: {
        countSuccess: 31,
        countExcluded: 2,
        countUnsuccessful: 16,
        countBadMissingData: 0,
      },
      countBehavioursTotal: 49,
      countBehavioursPerformable: 47,
    },
    PROMPT_DEPARTURE: {
      behaviourStatusCounts: {
        countSuccess: 17,
        countExcluded: 6,
        countUnsuccessful: 24,
        countBadMissingData: 0,
      },
      countBehavioursTotal: 47,
      countBehavioursPerformable: 41,
    },
    EFFICIENT_SFOC: {
      behaviourStatusCounts: {
        countSuccess: 72,
        countExcluded: 47,
        countUnsuccessful: 9,
        countBadMissingData: 8,
      },
      countBehavioursTotal: 137,
      countBehavioursPerformable: 81,
    },
  },
  [moment.utc().subtract(3, "months").format("YYYY/MM/DD")]: {
    EFFICIENT_AUXILIARY_ENGINE_USE: {
      behaviourStatusCounts: {
        countSuccess: 28,
        countExcluded: 14,
        countUnsuccessful: 27,
        countBadMissingData: 1,
      },
      countBehavioursTotal: 70,
      countBehavioursPerformable: 55,
    },
    OPTIMAL_TRIM: {
      behaviourStatusCounts: {
        countSuccess: 27,
        countExcluded: 6,
        countUnsuccessful: 8,
        countBadMissingData: 1,
      },
      countBehavioursTotal: 40,
      countBehavioursPerformable: 33,
    },
    PROMPT_DEPARTURE: {
      behaviourStatusCounts: {
        countSuccess: 11,
        countExcluded: 9,
        countUnsuccessful: 35,
        countBadMissingData: 1,
      },
      countBehavioursTotal: 56,
      countBehavioursPerformable: 46,
    },
    EFFICIENT_SFOC: {
      behaviourStatusCounts: {
        countSuccess: 60,
        countExcluded: 19,
        countUnsuccessful: 17,
        countBadMissingData: 9,
      },
      countBehavioursTotal: 105,
      countBehavioursPerformable: 77,
    },
  },
  [moment.utc().subtract(4, "months").format("YYYY/MM/DD")]: {
    EFFICIENT_AUXILIARY_ENGINE_USE: {
      behaviourStatusCounts: {
        countSuccess: 17,
        countExcluded: 42,
        countUnsuccessful: 22,
        countBadMissingData: 1,
      },
      countBehavioursTotal: 82,
      countBehavioursPerformable: 39,
    },
    OPTIMAL_TRIM: {
      behaviourStatusCounts: {
        countSuccess: 37,
        countExcluded: 5,
        countUnsuccessful: 22,
        countBadMissingData: 4,
      },
      countBehavioursTotal: 68,
      countBehavioursPerformable: 59,
    },
    PROMPT_DEPARTURE: {
      behaviourStatusCounts: {
        countSuccess: 27,
        countExcluded: 8,
        countUnsuccessful: 52,
        countBadMissingData: 0,
      },
      countBehavioursTotal: 87,
      countBehavioursPerformable: 79,
    },
    EFFICIENT_SFOC: {
      behaviourStatusCounts: {
        countSuccess: 55,
        countExcluded: 25,
        countUnsuccessful: 15,
        countBadMissingData: 7,
      },
      countBehavioursTotal: 102,
      countBehavioursPerformable: 70,
    },
  },
  [moment.utc().subtract(5, "months").format("YYYY/MM/DD")]: {
    EFFICIENT_AUXILIARY_ENGINE_USE: {
      behaviourStatusCounts: {
        countSuccess: 13,
        countExcluded: 37,
        countUnsuccessful: 18,
        countBadMissingData: 3,
      },
      countBehavioursTotal: 71,
      countBehavioursPerformable: 31,
    },
    OPTIMAL_TRIM: {
      behaviourStatusCounts: {
        countSuccess: 28,
        countExcluded: 5,
        countUnsuccessful: 13,
        countBadMissingData: 2,
      },
      countBehavioursTotal: 50,
      countBehavioursPerformable: 43,
    },
    PROMPT_DEPARTURE: {
      behaviourStatusCounts: {
        countSuccess: 28,
        countExcluded: 11,
        countUnsuccessful: 36,
        countBadMissingData: 0,
      },
      countBehavioursTotal: 75,
      countBehavioursPerformable: 64,
    },
    EFFICIENT_SFOC: {
      behaviourStatusCounts: {
        countSuccess: 67,
        countExcluded: 20,
        countUnsuccessful: 14,
        countBadMissingData: 14,
      },
      countBehavioursTotal: 115,
      countBehavioursPerformable: 81,
    },
  },
};

export const getBehaviourDataOverviewRespMaritime = (
  behaviourName,
  teamIds,
  startDate,
  endDate,
) => {
  let data = shippingAllTimeValues[behaviourName];
  if (startDate || endDate) {
    let monthsAgo =
      differenceInMonths(new Date(), new Date(endDate || startDate)) + 1;
    monthsAgo = monthsAgo > 5 ? 5 : monthsAgo; // just return the fifth month for any months further back in time
    monthsAgo = monthsAgo < 1 ? 1 : monthsAgo;
    data =
      shippingMonthyValues[
        moment.utc().subtract(monthsAgo, "months").format("YYYY/MM/DD")
      ][behaviourName];
  }
  if (teamIds?.length > 0) {
    data = halveAllObjectValues(data);
  }
  return data;
};
